(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ldy-card-bottone"] && !Shopify.designMode) return;
  try {
    // Lo stesso gestore di snippets/ldy-card-prodotto.liquid: si attacca una volta sola, chiunque arrivi primo.
  if (!window.ldyCardAggiungi) {
    window.ldyCardAggiungi = true;
    document.addEventListener('submit', async (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('[data-ldy-card-aggiungi]')) return;
      e.preventDefault();
      const bottone = form.querySelector('button');
      if (bottone) bottone.disabled = true;
      try {
        const { aggiungiAlCarrello, apriCassetto } = await import('@theme/ldy-carrello');
        await aggiungiAlCarrello(form, [{ id: Number(form.elements.id.value), quantity: 1 }], { fonte: 'ldy-card' });
        apriCassetto();
      } catch (err) {
        form.submit();
      } finally {
        if (bottone) bottone.disabled = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
